// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-responsive {
  max-height: 83vh;
  overflow-y: auto;
}
/* ReportRevenueDistributionItem.css (ou outro .css que você já importe) */
@media (max-width: 576px) {
  .table-responsive-card {
    max-height: 40vh !important;
  }
}
@media (min-width: 577px) {
  .table-responsive-card {
    max-height: 60vh !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentCss/ReportRevenueDistributionItem.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA,0EAA0E;AAC1E;EACE;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".table-responsive {\n  max-height: 83vh;\n  overflow-y: auto;\n}\n/* ReportRevenueDistributionItem.css (ou outro .css que você já importe) */\n@media (max-width: 576px) {\n  .table-responsive-card {\n    max-height: 40vh !important;\n  }\n}\n@media (min-width: 577px) {\n  .table-responsive-card {\n    max-height: 60vh !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
